/* Publish by EComposer at 2026-10-17 05:46:27*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lln6bwg3yvd"]=  window.__ectimmers["ecom-lln6bwg3yvd"] || {};
if(!this.settings||!this.$el||this.isLive)return;const t=this.$el;let e=t.querySelectorAll('script:not([type="application/json"])');e.length>0&&e.forEach(function(i){let s=document.createElement("script");s.type="text/javascript",s.innerText=i.innerText,i.src&&(s.src=i.src),t.appendChild(s),i.remove()})

                    });
                    
                        document.querySelectorAll('.ecom-lln6bwg3yvd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lln6bwg3yvd', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ixjabnjv189"]=  window.__ectimmers["ecom-ixjabnjv189"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ixjabnjv189').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ixjabnjv189', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cjwvvq5i40s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cjwvvq5i40s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cz1lwdjpejv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cz1lwdjpejv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ri1c4kq8ul8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ri1c4kq8ul8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fbwo4zuuwc6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fbwo4zuuwc6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-80kzrs8bd8i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-80kzrs8bd8i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xhxcgsw4pc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xhxcgsw4pc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bqxjkul53d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bqxjkul53d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zdqbxrm5wrn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zdqbxrm5wrn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0egtqbmwsddj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0egtqbmwsddj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xbm9ednyb6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xbm9ednyb6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-18e8vdudlf7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-18e8vdudlf7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-joq3uqq8svh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-joq3uqq8svh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a9w18qiy3qh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a9w18qiy3qh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hku6q8lui4q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hku6q8lui4q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fyt1s295mpi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fyt1s295mpi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-puo6pq7ox2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-puo6pq7ox2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jr5rx5w2z8o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jr5rx5w2z8o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sf2o6laagw9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sf2o6laagw9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3z6pe2f444x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3z6pe2f444x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3zvl9exvwpx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3zvl9exvwpx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5c0i45wx7bi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5c0i45wx7bi', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mb9kybcdwlp"]=  window.__ectimmers["ecom-mb9kybcdwlp"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),s=this.settings.action;function o(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var p;(p=d.ec_splide)==null||p.refresh()})},50),r())}e.forEach((a,l)=>{s==="click"||window.screen.width<1025?a.onclick=()=>o(a,l):a.onmouseover=()=>o(a,l)});function n(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let m=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,m)}}}setTimeout(()=>{n()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",n,!1)

                    });
                    
                        document.querySelectorAll('.ecom-mb9kybcdwlp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mb9kybcdwlp', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-r0urh1xhq1e"]=  window.__ectimmers["ecom-r0urh1xhq1e"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-r0urh1xhq1e"]["h0fptr4xx"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-r0urh1xhq1e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r0urh1xhq1e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t1gwy427knh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t1gwy427knh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rngjhs9lmng').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rngjhs9lmng', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zwnriyjuvhb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zwnriyjuvhb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kd3w5wa9qn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kd3w5wa9qn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hnp23szvnre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hnp23szvnre', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p9en6dostoe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p9en6dostoe', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oyhwrj7xvk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oyhwrj7xvk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a5l48g45ga7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a5l48g45ga7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ise974wsg1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ise974wsg1', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pmptswx7qba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pmptswx7qba', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r5ihb80wcr8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r5ihb80wcr8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i3ctac75em').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i3ctac75em', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hs5of0cfaz9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hs5of0cfaz9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yp0vyn71wde').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yp0vyn71wde', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ao4uwgwiab5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ao4uwgwiab5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x5nw1u9gpqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x5nw1u9gpqm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}